<template>
    <div class="left_b">
        <div class="lef">
        <el-row :gutter="20" justify="center">
            <el-col :span="6">
            <div  class="zht2"><el-icon :size="50"><Phone /></el-icon></div>
            <div>
                <span>客服电话</span> <br>
                <p >0577-88637368</p> 
                </div>
            </el-col>
            <el-col :span="6">
            <div  class="zht2"><el-icon :size="50"><Message /></el-icon></div>
            <div>
                <span>邮箱</span> <br>
                <p >wzsxgyy@qq.com</p> 
                </div>
            </el-col>
            <el-col :span="6">   
            <div  class="zht2"> <el-icon :size="50" ><MapLocation /></el-icon></div>
            <div>
                <span>地址</span> <br>
                <span>浙江省温州市瓯海区潘桥街道陈庄村横南路188号B幢</span> 
            </div>
            </el-col>
        </el-row>
        </div>

    </div>
    <div class="fs">
        <p style="margin-bottom:-10px;">
            <router-link  target="_blank" :to="{path:'/Img',query:{amgname:'xxfwzgz'}}" style="color:dodgerblue;font-size: 14px;">
                <el-image class="images3" :src="require('../../../public/img/imgs/互联网药品信息服务资格证书.jpg')"/>
            </router-link>&nbsp;&nbsp;
            <router-link  target="_blank" :to="{path:'/Img',query:{amgname:'yyzz'}}" style="color:dodgerblue;font-size: 14px;">
                <el-image class="images3" :src="require('../../../public/img/imgs/营业执照.jpg')"></el-image>
            </router-link>&nbsp;&nbsp;
            <router-link  target="_blank" :to="{path:'/Img',query:{amgname:'ypjy'}}" style="color:dodgerblue;font-size: 14px;">
                <el-image class="images3" :src="require('../../../public/img/imgs/药品经营许可证.jpg')"></el-image>
            </router-link>
        </p>
        <p style="margin-bottom:-10px;">
            <el-link :underline="false" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"> 
                浙ICP备10014557号-1
            </el-link> &nbsp;
            <el-link :underline="false" href="https://beian.mps.gov.cn/#/query/webSearch?code=33030402000288" target="_blank">            
                <el-image class="images2" :src="require('../../../public/img/icons/公安图标.png')"/>&nbsp;浙公网安备33030402000288号
            </el-link> &nbsp;
            <router-link  target="_blank" :to="{path:'/Img',query:{amgname:'xxfwzgz'}}" style="color:dodgerblue;font-size: 14px;">
            <el-link :underline="false" >        
                互联网药品服务资格证书 :(浙)-经营性-2021-0008.    
            </el-link> 
        </router-link>
        </p>
        <p><el-text>©2024温州市新光医药有限公司版权所有，并保留所有权利</el-text></p>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                amgname:''
            }
        }
    }
</script>

<style scoped>
.fs{
    width: 1200px;  margin: 0 auto;height: 50px;
    color: #8b8b8b;
    font-size: 15px;
    margin-bottom: 20px;
}

a {text-decoration: none;}

.images2{width: 18px;height: 18px;}
.images3{width: 90px;height: 70px;}


.lef{width: 1200px; 
    margin: 0 auto;
    text-align: left; 
    padding-top: 25px;
}
.left_b{  background-color: #e7e7e7;height: 120px;}

.zht2{float: left;margin-right: 5px;}
    /* .header-menu{height: 40px;line-height: 40px;  background-color:#E13335;} */
    /* .header-menu-top{float: left; width: 200px;}
    .header-menu-top2{float: left;  width: 750px;}
    
    .header-menu-top2 .el-menu .el-menu-item{font-size: 15px;}
    .footer{ width: 1200px;  margin: 0 auto;
      text-align:center;
       font-size:12px;
       color:#9c9c9c;
      margin-top:10px;}
      .footer p{margin: 10px;} 
    .footer p a{color:#9c9c9c;padding:0 10px;} */
    </style>